export const suggestedInventoryExpenseSheetProps = {
    key: 0,
    product_id: 0, 
    cost_per_unit: 0, 
    qty: 1, 
    subtotal: 0, 
    average_guests: 1, 
    cost_per_guest: 0
}

export const subMenuSubCategoryProps = {
    key: 0,
    recipe_id: 0,
    selected: true,
    qty_per_guest: 0,
    unit_cost: 0,
    total_cost: 0
}

export const subMenuProps = {
    key: 0,
    id: 0,
    sub_category: [JSON.parse(JSON.stringify(subMenuSubCategoryProps))],
    total_cost: 0,
    maximum_guest_count: false
}

export const finalFoodProps = {
    recipe_id: 0,
    sub_menu_id: 0,
    recipe_photo: '',
    item_name: '',
    item_type: 0,
    for_recipe_id: 0,
    major_guest: 0,
    minor_guest: 0,
    any_type_recipe: 0,
    veg_type_recipe: 0,
    vegan_type_recipe: 0,
    celiac_type_recipe: 0,
    total_guest: 0,
    side_dish_selected: false,
    selected: false
}

export let basicProps = {
    id: 0,
    menu_title: '',
    sales_price: 0,
    suggested_base_price: 0,
    suggested_profit_percent: 0,
    suggested_sales_price: 0,
    availability: 1, //1 = internal, 2 = external, 3 = both
    banner_image: '/assets/company-logo.png',
    suggested_inventory_expense_sheet: [],
    sub_menus: [JSON.parse(JSON.stringify(subMenuProps))]
}




// WEBPACK FOOTER //
// ./src/store/modules/foodMenus/properties.js